import React from 'react';
import styled from 'styled-components';
import Grid, {GridProps, GridSpacing} from '@material-ui/core/Grid';
import {useBreakpoints, useBreakpointQuery} from 'epic-ue-theme';

const Container = styled.div`
    margin: 0 auto;
    width: 100%;
    display: block;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    padding-left: ${(p) => `${p.theme.spacing(2)}px`};
    padding-right: ${(p) => `${p.theme.spacing(2)}px`};
    max-width: 100%;
    padding: 0;

    ${(p) => p.theme.breakpoints.up('xs')} {
        padding-left: ${(p) => `${p.theme.spacing(2)}px`};
        padding-right: ${(p) => `${p.theme.spacing(2)}px`};
    }

    ${(p) => p.theme.breakpoints.up('sm')} {
        padding-left: ${(p) => `${p.theme.spacing(3)}px`};
        padding-right: ${(p) => `${p.theme.spacing(3)}px`};
    }

    ${(p) => p.theme.breakpoints.up('md')} {
        padding-left: ${(p) => `${p.theme.spacing(5)}px`};
        padding-right: ${(p) => `${p.theme.spacing(5)}px`};
    }
    ${(p) => p.theme.breakpoints.up('lg')} {
        padding-left: ${(p) => `${p.theme.spacing(8)}px`};
        padding-right: ${(p) => `${p.theme.spacing(8)}px`};
        max-width: 1456px;
    }
    ${(p) => p.theme.breakpoints.up('xl')} {
        padding-left: ${(p) => `${p.theme.spacing(2)}px`};
        padding-right: ${(p) => `${p.theme.spacing(2)}px`};
    }
`;

interface ChildrenProps {
    children?: React.ReactNode;
}

export const GridContainer = (
    props: ChildrenProps & React.HTMLAttributes<HTMLDivElement>
): JSX.Element => {
    return (
        <Container {...props} className={`${props.className || ''} ue-grid-container`}>
            {props.children}
        </Container>
    );
};

export const CenteredGrid = (props: GridProps): JSX.Element => {
    const {children} = props;
    const breakpoints = useBreakpoints();
    const isSmMd = useBreakpointQuery(breakpoints.between('sm', 'md'));
    const isXs = useBreakpointQuery(breakpoints.down('xs'));

    let preferredSizing: GridSpacing = 4;
    if (isSmMd) {
        preferredSizing = 3;
    } else if (isXs) {
        preferredSizing = 2;
    }

    return (
        <Grid
            {...props}
            className={`${props.className || ''} ue-centered-grid`}
            container
            direction={props.direction || 'row'}
            justifyContent={props.justifyContent || 'flex-start'}
            alignItems={props.alignItems || 'center'}
            spacing={props.spacing || preferredSizing}>
            {children}
        </Grid>
    );
};

export const GridItem = (props: GridProps): JSX.Element => (
    <Grid {...props} item xs={3} sm={2} md={2} lg={1}>
        {props.children}
    </Grid>
);
